import { store } from 'v3/data/store';
import { ContractingStateEnum } from 'v3/data/store/contracting/enums';
import { filtersInitialState } from 'v3/data/store/contracting/state';
import { ContractingListType, ContractingType, FiltersType } from 'v3/data/store/contracting/types';
import { PaymentDataType } from 'v3/data/store/payment/types';
import { IStoreItem } from 'v3/data/store/stores/types';
import { paymentSlice } from '.';

export const setContractingList = (list: ContractingListType) => {
  store.dispatch(paymentSlice.actions.setPaymentList(list));
};

export const setFilters = (filters: FiltersType) => {
  store.dispatch(paymentSlice.actions.setFilters(filters));
};

export const clearFilters = () => {
  store.dispatch(paymentSlice.actions.setFilters(filtersInitialState));
};

export const setFilterCurrentPage = (value: number) => {
  store.dispatch(paymentSlice.actions.setFilterCurrentPage(value));
};

export const setFilterRowsPerPage = (value: number) => {
  store.dispatch(paymentSlice.actions.setFilterRowsPerPage(value));
};

export const setFilterRowsToSkip = (value: number) => {
  store.dispatch(paymentSlice.actions.setFilterRowsToSkip(value));
};

export const setContractingKey = (value: string) => {
  store.dispatch(paymentSlice.actions.setContractingKey(value));
};

export const setContractingState = (value: ContractingStateEnum) => {
  store.dispatch(paymentSlice.actions.setPaymentState(value));
};

export const setTokenValid = (tokenValid: boolean) => {
  store.dispatch(paymentSlice.actions.setTokenValid(tokenValid));
};

export const setContractingSelected = (contracting: ContractingType) => {
  store.dispatch(paymentSlice.actions.setPaymentSelected(contracting));
};

export const setTimeRemaining = (timeRemaining: string) => {
  store.dispatch(paymentSlice.actions.setTimeRemaining(timeRemaining));
};

export const setStoreIdsListFilter = (storeIdsList: string[]) => {
  store.dispatch(paymentSlice.actions.setStoreIdsList(storeIdsList));
};

export const setContractSignDate = (contractSignDate: string) => {
  store.dispatch(paymentSlice.actions.setContractSignDate(contractSignDate));
};

export const setTotalContractings = (totalContractings: number) => {
  store.dispatch(paymentSlice.actions.setTotalContractings(totalContractings));
};

export const setAllStoresIds = (list: IStoreItem[]) => {
  store.dispatch(paymentSlice.actions.setAllStoresIds(list));
};

export const setInitialStoreIdsRequest = (initialStoreIdsRequest: boolean) => {
  store.dispatch(paymentSlice.actions.setInitialStoreIdsRequest(initialStoreIdsRequest));
};

export const setPaymentData = (paymentData: PaymentDataType) => {
  store.dispatch(paymentSlice.actions.setPaymentData(paymentData));
};
